import { matchPath, useLocation } from 'react-router-dom';
import INFO_OVERLAY_RULES, { InfoOverlayLink } from '../components/InfoOverlay/infoOverlayConfig';

const NO_LINKS: InfoOverlayLink[] = [];

export default function useInfoOverlayLinks(): InfoOverlayLink[] {
  const { pathname } = useLocation();

  const rule = INFO_OVERLAY_RULES.find(
    item => matchPath({ path: item.path, end: item.exact ?? true }, pathname) !== null,
  );

  return rule?.links.filter(link => link.href !== '') ?? NO_LINKS;
}
